import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { ReportService } from '../shared/report.service';
import { ReportesViewComponent } from './reportes-view.component';
import { ReportFilter } from '../shared/report.filter.model';
import { Merchant } from '../shared/merchant.model';
import { Observable } from 'rxjs';
import { OperationStatus } from './operation-status.model';
import { ServiceInstance } from './service-instance.model';
import { OperationType } from './operation-type-model';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { NaturalezaContable } from '../bines/naturaleza-contable';
import { ITarjeta } from '../tarjetas/tarjeta';

@Component({
  selector: 'pm-report-filter',
  templateUrl: './report-filter.component.html',
  styleUrls: ['./report-filter.component.sass']
})
export class ReportFilterComponent implements OnInit, OnDestroy {
  @Input() incomingReportFilter: ReportFilter;
  @Input() datePickerConfig: Partial<BsDatepickerConfig>;
  // @Input() formData = { dateRange: [new Date(), new Date()] };

  @Input() merchantList: Merchant[];
  @Input() operationStatusList: Observable<OperationStatus[]>;
  @Input() serviceInstanceList: Observable<ServiceInstance[]>;
  @Input() operationTypeList: Observable<OperationType[]>;
  @Input() accountingNatureList: Observable<NaturalezaContable[]>;
  @Input() cardBrandList: Observable<ITarjeta[]>;

  @Output() createReportEvt: EventEmitter<ReportFilter>;
  @Output() queryTxnsEvt: EventEmitter<ReportFilter>;

  constructor(public service: ReportService, public parent: ReportesViewComponent) {
    this.createReportEvt = new EventEmitter();
    this.queryTxnsEvt = new EventEmitter();
  }

  ngOnInit() {}

  onCreateReport() {
    this.parent.showFilter = false;
    // console.log('onCreateReport: merchantObj: ', this.incomingReportFilter.merchantObj);
    // console.log('onCreateReport: status: ', this.incomingReportFilter.status);
    // console.log('onCreateReport: accountingNature: ', this.incomingReportFilter.accountingNature);
    this.createReportEvt.emit(this.incomingReportFilter);

    // this.txnMerchantSelected.emit(this.txnMonitorFilter);
    // this.txnStatusSelected.emit(this.statusSelected);
    // this.txnAccountingNature.emit(this.accountingNature);
  }

  onQueryTxns() {
    this.parent.showFilter = false;
    this.queryTxnsEvt.emit(this.incomingReportFilter);
  }

  cancelTxnReportFilter() {
    this.parent.showFilter = false;
  }

  ngOnDestroy() {}
}
